/**
 * Project: redwood-ui-components
 * FilePath: /src/client/app/applications/papyrus-search-quick/SearchQuick.js
 * File: SearchQuick.js
 * Created Date: Friday, April 5th 2019, 11:42:59 am
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Apr 05 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Pixel Ventures Ltd.
 * ------------------------------------
 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { FusePageSimple } from 'modules/@fuse'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import { QuickSearch } from 'papyrus-ui-components'

// const _props = require('./__data__/apiSearch.json')

const styles = theme => ({
  layoutRoot: {}
})

class PapyrusSearchQuickSandbox extends Component {
  static contextTypes = {
    store: PropTypes.object
  }

  constructor (props, context) {
    super(props, context)
    this.state = {}
  }

  render () {
    const {
      loading,
      typeDefLoading,
      classes
    } = this.props

    return typeDefLoading || loading ? (
      <p>Loading...</p>
    ) : (
      <FusePageSimple
        classes={{
          root: classes.layoutRoot
        }}
        content={
          <div style={{ height: '100vh' }}>
            <QuickSearch
              store={this.context.store}
              websocket={{
                corrIdGen: () => { console.log('CALLED CORRIDGEN') },
                rpc: () => { console.log('CALLED RPC') },
                stream: () => { console.log('CALLED STREAM') }
              }}
            />
          </div>
        }
        onRef={instance => {
          this.pageLayout = instance
        }}
      />
    )
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({

  }, dispatch)
}

function mapStateToProps ({ documentList }) {
  return {}
}

export default
withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(PapyrusSearchQuickSandbox)
  )
)
